module.exports = __webpack_public_path__ + "img/guigeliao7.280a0b83.jpg";